<template>
  <screen-element-date-range-picker
    class="screen-date-range"
    :value="value"
    type="daterange"
    format="yyyy/MM/dd"
    value-format="yyyy-MM-dd"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :clearable="false"
    :editable="false"
    popper-class="screen-date-range-popper"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  />
</template>

<script>
import { DatePicker } from 'element-ui'
import withMonthSidebar from './ScreenDateRangePanel'

export default {
  name: 'ScreenDateRangePicker',
  components: {
    ScreenElementDateRangePicker: {
      extends: DatePicker,
      created() {
        this.panel = withMonthSidebar(this.panel)
      },
      destroyed() {
        if (this.picker) {
          this.picker.$destroy()
          this.picker.$off()
          this.picker = null
        }
      }
    }
  },
  props: {
    value: { type: Array, default: () => [] }
  }
}
</script>

<style>
.screen-date-range.el-range-editor {
  width: 300px;
  max-width: 100%;
  height: 34px;
  padding: 3px 10px;
  border: 1px solid rgba(104, 205, 255, 0.6);
  border-radius: 6px;
  background: rgba(5, 47, 109, 0.9);
}
.screen-date-range .el-range-input {
  color: #e1f5ff;
  font-size: 13px;
  background: transparent;
}
.screen-date-range .el-range-separator {
  width: 24px;
  padding: 0;
  color: #a9dfff;
  line-height: 26px;
}
.screen-date-range .el-range__icon {
  color: #a9dfff;
  line-height: 26px;
}
.screen-date-range-popper.el-picker-panel {
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);
  overflow-y: auto;
  border-color: #278bc8;
  color: #d9f0ff;
  background: #07336c;
}
.screen-date-range-popper.el-date-range-picker.has-sidebar {
  width: 794px;
}
.screen-date-range-popper.has-sidebar .el-picker-panel__body {
  margin-left: 148px;
}
.screen-date-range-popper .el-picker-panel__sidebar {
  width: 148px;
  padding: 10px 8px;
  overflow: visible;
  border-color: #278bc8;
  background: #062c60;
}
.screen-date-range-month {
  width: 100%;
  margin-bottom: 8px;
}
.screen-date-range-month .el-input__inner {
  padding-left: 8px;
  border-color: #278bc8;
  color: #e1f5ff;
  background: #07336c;
}
.screen-date-range-month .el-input__inner::placeholder,
.screen-date-range-month .el-input__suffix {
  color: #badfff;
}
.screen-month-options.el-select-dropdown {
  border-color: #278bc8;
  background: #07336c;
}
.screen-month-options .el-select-dropdown__wrap {
  max-height: 208px;
}
.screen-month-options .el-select-dropdown__item,
.screen-month-options .el-select-dropdown__empty {
  color: #badfff;
}
.screen-month-options .el-select-dropdown__item.hover,
.screen-month-options .el-select-dropdown__item:hover {
  background: #125aa0;
}
.screen-month-options .el-select-dropdown__item.selected {
  color: #e1f5ff;
}
.screen-month-options .popper__arrow,
.screen-month-options .popper__arrow::after {
  border-bottom-color: #07336c;
  border-top-color: #07336c;
}
.screen-date-range-popper .el-picker-panel__shortcut,
.screen-date-range-popper .el-date-table th,
.screen-date-range-popper .el-picker-panel__icon-btn {
  color: #badfff;
}
.screen-date-range-popper .el-date-table td.next-month,
.screen-date-range-popper .el-date-table td.prev-month {
  color: #7892b6;
}
.screen-date-range-popper .el-date-table td.in-range div,
.screen-date-range-popper .el-date-table td.in-range div:hover {
  background: #125aa0;
}
.screen-date-range-popper .el-date-range-picker__content.is-left,
.screen-date-range-popper .el-date-table th {
  border-color: rgba(77, 163, 222, 0.4);
}
.screen-date-range-popper .popper__arrow {
  border-bottom-color: #278bc8;
  border-top-color: #278bc8;
}
.screen-date-range-popper .popper__arrow::after {
  border-bottom-color: #07336c;
  border-top-color: #07336c;
}
@media (max-width: 700px) {
  .screen-date-range-popper.el-date-range-picker.has-sidebar {
    width: calc(100vw - 24px);
  }
  .screen-date-range-popper .el-picker-panel__sidebar {
    position: static;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px;
    border-right: 0;
    border-bottom: 1px solid #278bc8;
  }
  .screen-date-range-month {
    width: 132px;
    margin-bottom: 0;
  }
  .screen-date-range-shortcuts {
    display: flex;
    flex-wrap: wrap;
  }
  .screen-date-range-popper .el-picker-panel__shortcut {
    width: auto;
  }
  .screen-date-range-popper.has-sidebar .el-picker-panel__body {
    margin-left: 0;
    min-width: 0;
  }
  .screen-date-range-popper .el-date-range-picker__content {
    float: none;
    width: 100%;
    padding: 12px;
  }
  .screen-date-range-popper .el-date-range-picker__content.is-left {
    border-right: 0;
    border-bottom: 1px solid rgba(77, 163, 222, 0.4);
  }
}
</style>
